import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"id":"axis-select","items":_vm.axis,"item-text":"nome","item-value":"usuarioGrupoId","placeholder":"Grupos","multiple":""},on:{"change":_vm.change},model:{value:(_vm.filter.hierarquia),callback:function ($$v) {_vm.$set(_vm.filter, "hierarquia", $$v)},expression:"filter.hierarquia"}},[_c('template',{slot:"no-data"},[_vm._v(" Nenhum Grupos retornado ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }